import ChangePassword from './ChangePasswordDef';
import ZipCode from './ZipCodeDef';
import Countries from './CountriesDef';
import RecoverMemberNumber from './RecoverMemberNumberDef';
import TokenSms from './TokenSmsDef';
import TokenEmail from './TokenEmailDef';
import ValidateEmail from './ValidateEmailRegisterDef';
import ValidateDocument from './ValidateDocumentDef';
import RecoverBigDataQuestion from './RecoverBigDataQuestionDef';
import ValidateBigDataQuestion from './ValidateBigDataQuestionDef';
import MemberInfo from './MemberInfoDef';
import MaskedContact from './MaskedContactDef';
import AccountIssue from './AccountIssueDef';
import ResetPasswordAccountIssue from './ResetPasswordAccountIssueDef';
import ResetPassword from './ResetPasswordDef';
import UploadFileS3 from './UploadFileS3Def';
import MemberStatus from './MemberStatusDef';
import Member from './MemberDef';
import UpdateMemberSensitiveData from './UpdateMemberSensitiveDataDef';
import ValidateLegalGuardian from './ValidateLegalGuardianDef';
import Dependents from './DependentsDef';
import SendTokenEmail from './SendTokenEmailDef';
import CheckUpdateMemberStatus from './CheckUpdateMemberStatusDef';

export default {
  ChangePassword,
  ZipCode,
  Countries,
  RecoverMemberNumber,
  TokenSms,
  TokenEmail,
  ValidateEmail,
  ValidateDocument,
  RecoverBigDataQuestion,
  ValidateBigDataQuestion,
  MemberInfo,
  MaskedContact,
  AccountIssue,
  ResetPasswordAccountIssue,
  ResetPassword,
  UploadFileS3,
  MemberStatus,
  Member,
  UpdateMemberSensitiveData,
  ValidateLegalGuardian,
  Dependents,
  SendTokenEmail,
  CheckUpdateMemberStatus,
};
